<template>
    <div>
        <div>
            <!-- <Balance ref="Balance"></Balance> -->
            <el-row :gutter="20">
                <el-col :xm="24" :md="12" :lg="14" style="margin-bottom:30px;">
                    <div class="biaoqian">混剪视频制作</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <div style="font-size: 14px;">
                            <qhyupload ref="qhyupload"></qhyupload>
                            <div style="margin-top:25px;">
                                <div style="margin:10px 0px;font-weight: 600;color: #666;">混剪模式</div>
                                <div style="display: flex;flex-wrap: wrap;font-size: 13px;color: #fff;">
                                    <div v-for="(item, index) in ms_data.ms_list" :key="index"
                                        style="background-color: #eaeaea;border-radius: 5px;display: flex;justify-content: center;align-items: center;padding: 7px 14px;color: #5a5a5a;margin: 6px;cursor: pointer;"
                                        @click="ms_xz = item"
                                        :style="{ backgroundColor: (ms_xz.name == item.name ? '#484add' : '#eaeaea'), color: (ms_xz.name == item.name ? '#fff' : '#5a5a5a') }">
                                        <div class="no-select">{{ item.name }}</div>
                                    </div>
                                </div>
                                <div style="margin-top: 5px;font-size: 12px;color: #999;">
                                    功能介绍: {{ ms_xz.title }}
                                </div>
                            </div>
                            <div style="margin-top:25px;">
                                <div style="margin:10px 0px;font-weight: 600;color: #666;">附加选项
                                    <a style="font-size: 1.3vh;color: #999;">(建议最多5个)</a>
                                </div>
                                <div style="display: flex;flex-wrap: wrap;font-size: 13px;color: #fff;">
                                    <div v-for="(item, index) in ms_data.other" :key="index"
                                        style="background-color: #eaeaea;border-radius: 5px;display: flex;justify-content: center;align-items: center;padding: 7px 14px;color: #5a5a5a;margin: 6px;cursor: pointer;"
                                        @click="item.zt = !item.zt"
                                        :style="{ backgroundColor: (item.zt ? '#484add' : '#eaeaea'), color: (item.zt ? '#fff' : '#5a5a5a') }">
                                        <div class="no-select">{{ item.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top:25px;">
                                <div style="margin:10px 0px;font-weight: 600;color: #666;">更多设置</div>
                                <div style="display:flex;justify-content: space-between;align-items: center;">
                                    <div>固定音乐</div>
                                    <div style="color:#888;">
                                        为第<el-input-number v-model="hj_data.music" :min="0" label="描述文字" size="mini"
                                            style="width: 100px;margin: 0px 5px;"></el-input-number>个视频
                                    </div>
                                </div>
                                <div
                                    style="display:flex;justify-content: space-between;align-items: center;margin-top: 20px;">
                                    <div>固定开头</div>
                                    <div style="color:#888;">
                                        为第<el-input-number v-model="hj_data.kt" :min="0" label="描述文字" size="mini"
                                            style="width: 100px;margin: 0px 5px;"></el-input-number>个视频
                                    </div>
                                </div>
                                <div
                                    style="display:flex;justify-content: space-between;align-items: center;margin-top: 20px;">
                                    <div>生成视频数量</div>
                                    <div style="color:#888;">
                                        <el-input-number v-model="hj_data.num" :min="1" :max="10" label="描述文字"
                                            size="mini"></el-input-number>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top:30px;">
                                <el-button @click="ks()"
                                    style="width:100%;background-color: #484add;border-color: #484add;"
                                    type="success">立即制作</el-button>
                            </div>
                        </div>

                    </el-card>
                </el-col>
                <el-col :xm="24" :md="12" :lg="10">
                    <div class="biaoqian">制作记录</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <div style="font-size: 14px;">
                            <!-- <div style="margin:10px 0px;">制作记录</div> -->
                            <Record></Record>
                        </div>

                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Record from "../User/Record.vue"
import Balance from "./Balance.vue";
export default {
    name: '',
    components: {
        Record,
        Balance
    },
    // 定义属性
    data() {
        return {
            allurl: '',
            video: [],
            spnum: 0,

            make_num: 1,
            gd_music: 1,
            make_type: '链接上传',

            videoFileList: [],
            video_num: 0,
            upload_fq: [],
            ksing: false,

            ms_data: [],
            ms_xz: '其他混剪',
            ms_other: '',
            hj_data: {
                music: 0,
                kt: 0,
                num: 1,
            },
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        check_other(e) {
            console.log(e)
            // hj_data[item.value] = !hj_data[item.value]
        },
        async handleUpload() {
            for (let i = 0; i < this.videoFileList.length; i++) {
                const file = this.videoFileList[i];
                await this.upload_sp_bd(file);
            }
        },
        async upload_sp_bd(param) {
            console.log('bd', param)
            var that = this
            param.status = 'uploading';    //文件上传状态
            param.percentage = 0;    //文件上传进度，这里设为0
            // param.name = param.name    //文件名
            // this.videoFileList.push(param)    //添加到选择文件列表

            let fdata = new window.FormData();
            fdata.append('file', param.raw)
            fdata.append('token', this.upload_fq.token)
            await this.$ajax_upload.post(this.upload_fq.upload_url, fdata, {
                onUploadProgress: function (progressEvent) { // 处理上传进度事件
                    let percent = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);   //计算出上传的进度，去整数位
                    param.percentage = percent;  //动态设置param的percentage
                    // console.info(percent)
                }
            }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(response => {
                //请求成功
                console.log(response.data);
                if (response.data.code == 200) {
                    param.spdz = that.upload_fq.host + response.data.dz
                    param.status = 'success';
                    that.video_num--
                    if (that.video_num == 0) {
                        console.log(this.videoFileList)
                        var okurl = ''
                        for (let index = 0; index < this.videoFileList.length; index++) {
                            okurl += this.videoFileList[index].spdz + '\n';

                        }
                        var data = {
                            'url': okurl,
                            'ms': this.ms,
                            'xgcs': this.make_num,
                            'gd_music': this.hj_data.music,
                            'gd_kt': this.hj_data.kt,
                            'hj_xz': this.ms_xz['name'],
                            'type': 31,
                        }
                        that.$ajax.post('/qhy/user/makevieo', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                            console.log(res.data)
                            if (res.data.status == 200) {
                                that.ksing = false
                                that.video_num = 0
                                that.$alert('视频任务上传提交成功', '视频上传', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        that.videoFileList = []
                                        // that.$refs.Balance.get_user()
                                        this.$parent.$parent.$parent.$parent.get_balance()
                                    }
                                });

                            } else {
                                this.$toast.show(res.data.msg)
                            }

                        })

                    }
                } else {
                    param.status = 'failed';
                    param.message = '上传失败';
                }



            }).catch(function (error) {
                // 请求失败处理
                console.log(error);
                param.status = 'failed';
                param.message = '上传失败';
            });
        },
        upload_fc(file) {

        },
        upload_fast(file) {
            console.log(file)
            if (file.type == 'video/mp4' || file.type == 'video/quicktime') {

            } else {
                this.$message.error('上传视频只能是 mp4或mov 格式!');
                return false
            }

            const isLt2M = file.size / 1024 / 1024 < 100;

            if (!isLt2M) {
                this.$message.error('上传视频大小不能超过 100MB!');
                return false
            }
            return true;
        },
        upload_xianzhi(files, fileList) {
            this.$message.warning(`当前限制选择 15 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        upload_remove(file, fileList) {
            // console.log(fileList)
            const index = this.videoFileList.indexOf(file);
            // console.log(index)
            this.videoFileList.splice(index, 1);
            this.video_num = fileList.length
        },
        upload_change(file, fileList) {
            // console.log(fileList)
            this.video_num = fileList.length
            this.videoFileList.push(file);
        },

        url_jc() {
            console.log(this.allurl.split('\n'))
            this.spnum = this.allurl.split('\n').length
            this.video = []
        },
        ks() {
            var urls = this.$refs.qhyupload.get_urls()
            if (urls.status == 100) {
                return this.$msg.error(urls.msg)
            }
            var ms = this.ms_xz.name + '-'
            for (var i = 0; i < this.ms_data.other.length; i++) {
                if (this.ms_data.other[i].zt) {
                    ms += this.ms_data.other[i].value
                }
            }
            var data = {
                'url': urls,
                'ms': ms,
                'other': JSON.stringify(this.hj_data),
                'type': 32
            }
            console.log(data)
            const loading = this.$loading(this.$loadinginfo);

            this.$ajax.post('/qhy/user/makevieo', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    // console.log(index)
                    // this.$msg.success(res.data.msg)
                    this.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        customClass: 'newdialog',
                        callback: action => {
                            const balanceComp = this.$parent.$parent.$parent.$parent
                            if (balanceComp && typeof balanceComp.get_balance === 'function') balanceComp.get_balance()
                            this.allurl = ''
                            this.$refs.qhyupload.clear_url()
                        }
                    });
                    // this.$refs.Balance.get_user()
                } else {
                    this.$msg.error(res.data.msg)
                }
            }).finally(() => {
                this.uploading = false
                loading.close();
            })
        },
        ksold(appointed = '') {

            if (this.make_type == '视频上传') {
                if (this.video_num < 2) {
                    // this.$msg.error('请填写要制作的视频')
                    this.$toast.show("最少上传2个视频混剪", 3000);
                    return
                }
                console.log(this.video_num)
                var data = {
                    'num': 1,
                    'xgcs': this.make_num
                }
                this.$ajax.post('/qhy/user/balance_xy_web', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 200) {
                        if (res.data.msg == 'mod2') {
                            this.upload_fq = res.data.data
                        }
                        this.ksing = true
                        // this.$refs.upload.submit();
                        this.handleUpload()

                    } else {
                        this.$msg.error(res.data.msg)
                    }

                })

            } else {
                var ms = this.ms_xz
                console.log(ms)
                if (this.allurl.length <= 0) {
                    // this.$msg.error('请填写要制作的视频')
                    this.$toast.show("请填写要制作的视频", 3000);
                    return
                }
                if (this.spnum > 4) {
                    this.$msg.error('混剪一次性只能提交4个链接')
                    return
                }
                this.ksing = true
                const loading = this.$loading(this.$loadinginfo);

                var data = {
                    'url': this.allurl,
                    'ms': this.ms,
                    'xgcs': this.make_num,
                    'gd_music': this.hj_data.music,
                    'gd_kt': this.hj_data.kt,
                    'hj_xz': this.ms_xz['name'],
                    'type': 3,
                    'appointed': appointed
                }
                this.$ajax.post('/qhy/user/makevieo', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 200) {
                        // console.log(index)
                        this.$msg.success(res.data.msg)
                        // this.$refs.Balance.get_user()
                        this.$parent.$parent.$parent.$parent.get_balance()
                        this.allurl = ''
                        this.make_num = 1
                        this.gd_music = 1
                    } else {
                        this.$msg.error(res.data.msg)
                    }
                    loading.close();
                    this.ksing = false
                })
            }


        },
        num_fc(e) {
            // console.log(e)
        },
        get_ms() {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('/qhy/user/ms_hj', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.ms_data = res.data.data
                    this.ms_xz = this.ms_data.ms_list[0]
                    for (let index = 0; index < this.ms_data.other.length; index++) {
                        const element = this.ms_data.other[index];
                        this.hj_data[element.value] = 0
                    }
                }

                loading.close();
            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.common.ismobile(this)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.get_ms()
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.upload2 .el-upload {
    width: 100%;
}

.upload2 .el-upload-dragger {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Hj.vue



// WEBPACK FOOTER //
// src/components/User/Hj.vue